import { Resources } from '../../../../models/ScheduleResource';

export const productComparetor = (leftProduct: Resources, rightProduct: Resources) => {
  if (!leftProduct.priority || !rightProduct.priority) return 0;
  if (leftProduct.priority === rightProduct.priority) return 0;
  return leftProduct.priority - rightProduct.priority;
};
